import { render, staticRenderFns } from "./new-review.pug?vue&type=template&id=26319519&lang=pug&"
import script from "./new-review.ts?vue&type=script&lang=ts&"
export * from "./new-review.ts?vue&type=script&lang=ts&"
import style0 from "./new-review.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports